<template lang="pug">
  footer.footer
    .container-fluid
      .footer__block
        nav.footer__nav(v-if="lang==='ru'")
          li.footer__li(v-for="(name, key) in nav1", :key="key")
            a.footer__link.text-uppercase(:href="`#${key}`", v-smooth-scroll="{ offset: -100 }", v-html="name")
        nav.footer__nav(v-if="lang==='en'")
          li.footer__li(v-for="(name, key) in nav2", :key="key")
            a.footer__link.text-uppercase(:href="`#${key}`", v-smooth-scroll="{ offset: -100 }", v-html="name")
      .footer__block
      div(v-if="lang==='ru'")
        h3.sendheader Отправить сообщение
      div(v-if="lang==='en'")
        h3.sendheader Send message
      form.transparent(v-on:submit.prevent="sendEmail")
        div.form-inner
          label(v-if="lang==='ru'") Имя
          label(v-if="lang==='en'") Name
          br
          input(type="text", name="user_name")
          br
          label(v-if="lang==='ru'") Почта
          label(v-if="lang==='en'") e-Mail
          br
          input(type="text", name="user_mail", v-model="mail")
          br
          label(v-if="lang==='ru'") Телефон
          label(v-if="lang==='en'") Phone
          br
          input(type="text", name="user_phone", v-model="phone")
          br
          label(v-if="lang==='ru'") Сообщение
          label(v-if="lang==='en'") Message
          br
          textarea(v-model="textAr", name="message")
          br
          div(class="g-recaptcha" data-sitekey="6LdFpYEaAAAAAEGLF3Rq5IydPsNRvreDt6G1kwXq")
          br
          input(v-if="lang==='ru'", type="submit", value="Отправить")
          input(v-if="lang==='en'", type="submit", value="Send")
      div.copyright(v-if="lang==='ru'") © Новая логистическая 2025
      div.copyright(v-if="lang==='en'") © NEW LOGISTIC 2025
</template>

<script>
  import emailjs from 'emailjs-com'
  export default {
    name: 'Footer',
    data() {
      return {
        nav1: {
          service: 'Услуги',
          geography: 'География',
          about: 'О&nbsp;компании',
          // 'container-service': 'Контейнерные сервисы',
          // team: 'Команда',
          contacts: 'Контакты'
        },
        nav2: {
          service: 'SERVICES',
          geography: 'GEOGRAPHY',
          about: 'ABOUT&nbsp;US',
          // 'container-service': 'Контейнерные сервисы',
          // team: 'Команда',
          contacts: 'CONTACTS'
        },
        social: ['fb', 'vk'],
        textAr: null,
        phone: null,
        mail: null
      }
    },
    props: {
      lang: String
    },
    methods: {
      socialIcon(name) {
        return `#${name}--sprite`
      },
      sendEmail: function(e) {
        console.log()
        if (!this.mail && !this.phone) {
          if (e.submitter.defaultValue === 'Отправить') {
            alert('Укажите почту и/или телефон')
            return
          }
          if (e.submitter.defaultValue === 'Send') {
            alert('Enter e-mail address and/or phone number')
            return
          }
        }
        if (this.mail && !this.validEmail(this.mail)) {
          if (e.submitter.defaultValue === 'Отправить') {
            alert('Невалидный e-mail адрес')
            return
          }
          if (e.submitter.defaultValue === 'Send') {
            alert('Invalid e-mail address')
            return
          }
        }
        if (this.phone && !this.validPhone(this.phone)) {
          if (e.submitter.defaultValue === 'Отправить') {
            alert('Невалидный телефон')
            return
          }
          if (e.submitter.defaultValue === 'Send') {
            alert('Invalid phone number')
            return
          }
        }
        emailjs.sendForm('service_yby2908', 'template_3cbeg7p', e.target, 'user_B27uK73VTSsj993pDsIeT')
          .then((result) => {
            if (e.submitter.defaultValue === 'Отправить') {
              alert('Сообщение отправлено!')
            }
            if (e.submitter.defaultValue === 'Send') {
              alert('Message sended!')
            }
            console.log('SUCCESS!', result.status, result.text)
          }, (error) => {
            if (e.submitter.defaultValue === 'Отправить') {
              alert('Сообщение НЕ отправлено!')
            }
            if (e.submitter.defaultValue === 'Send') {
              alert('Message NOT sended!')
            }
            console.log('FAILED...', error)
          })
      },
      validEmail: function(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      },
      validPhone: function(phone) {
        var re = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/
        return re.test(phone)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../style/variables";
  .footer {
    z-index: 1;
    color: white;
    position: relative;
    background-color: #1F2B39;
    &__block {
      display: flex;
      padding: 38px 0;
      align-items: center;
      justify-content: space-between;
    }
    &__nav {
      display: flex;
      list-style: none;
    }
    &__li {
      &:not(:first-child) {
        margin-left: 40px;
      }
      &--small-offset {
        &:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
    &__link {
      color: inherit;
    }
    &__social {
      $s: 40px;
      width: $s;
      height: $s;
      border-radius: 50%;
      background-color: #878887;
    }
    .copyright, .design {
      font-weight: 300;
    }
    .design {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
.transparent {
   position: relative;
   max-width: 800px;
   padding: 60px 50px;
   margin: 50px auto 0;
}
.transparent:before {
   content: "";
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
}
.form-inner {
   position: relative;
}
.form-inner h3 {
   position: relative;
   margin-top: 0;
   color: white;
   font-family: 'Roboto', sans-serif;
   font-weight: 300;
   font-size: 26px;
   text-transform: uppercase;
}
.form-inner h3:after {
   content: "";
   position: absolute;
   left: 0;
   bottom: -6px;
   height: 2px;
   width: 60px;
   background: #1762EE;
}
.form-inner label {
   display: block;
   padding-left: 15px;
   font-family: 'Roboto', sans-serif;
   color: rgba(255, 255, 255, .6);
   text-transform: uppercase;
   font-size: 14px;
}
.form-inner input {
   display: block;
   width: 100%;
   padding: 0 15px;
   margin: 10px 0 15px;
   border-width: 0;
   line-height: 40px;
   border-radius: 20px;
   color: white;
   background: rgba(255, 255, 255, .2);
   font-family: 'Roboto', sans-serif;
}
.form-inner textarea {
   display: block;
   width: 100%;
   padding: 0 15px;
   margin: 10px 0 15px;
   border-width: 0;
   line-height: 40px;
   border-radius: 20px;
   color: white;
   background: rgba(255, 255, 255, .2);
   font-family: 'Roboto', sans-serif;
}
.form-inner input[type="checkbox"] {
   position: absolute;
   opacity: 0;
}
#custom-checkbox+label {
   position: relative;
   margin: 20px 0;
   text-transform: none;
   cursor: pointer;
}
#custom-checkbox+label:before {
   content: "";
   display: inline-block;
   width: 20px;
   height: 20px;
   margin-right: 10px;
   vertical-align: text-top;
   background: white;
}
#custom-checkbox:checked+label:before {
   background: #1762EE;
}
#custom-checkbox:checked+label:after {
   content: "";
   position: absolute;
   width: 2px;
   height: 2px;
   left: 20px;
   top: 9px;
   background: white;
   box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
   transform: rotate(45deg);
}
.form-inner input[type="submit"] {
   background: #1762EE;
}
.sendheader {
  text-align: center;
}
</style>
